import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { GetNotificationListReqData, GetNotificationListResData, SendNotificationReqData, SendNotificationResData } from 'models/CL/CLApiTypes';

class NotificationsApi {
  async getNotificationList(rqData: GetNotificationListReqData, token: string): Promise<GetNotificationListResData> {
    try {
      const response = await axios.get(`${apiPaths.CLGetNotificationList}?userId=${rqData.userId}&offset=${rqData.offset}&limit=${rqData.limit}`, {
        headers: tokenHeader(token),
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async sendNotification(rqData: SendNotificationReqData, token: string): Promise<SendNotificationResData> {
    try {
      const response = await axios.post(`${apiPaths.CLSendNotification}`, rqData, {
        headers: tokenHeader(token),
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const CLNotificationsApi = new NotificationsApi(); 